import type { SvgIconProps } from './types';

export function CaretDownIcon(props: SvgIconProps) {
  return (
    <svg className="caret-down" fill="currentColor" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M31.5 192h257c26.5 0 40 31.9 21.1 51L195.1 348c-11.8 12.2-30.4 12.2-42.2 0L38.4 243c-18.8-19.1-5.4-51 21.1-51z"></path>
        </svg>
  );
}
